/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgKeyValueExtraction = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h7v9h2.586l-1.293-1.293 1.414-1.414 3 3 .707.707-.707.707-3 3-1.414-1.414L11.586 13H9v9H2V2zm2 2v16h3V4H4zm12-2h6v6h-6V2zm2 2v2h2V4h-2zm-1 5h-1v6h6V9h-5zm3 4h-2v-2h2v2zm-4 3h6v6h-6v-6zm2 2v2h2v-2h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgKeyValueExtraction as KeyValueExtraction };
